import { render } from "./Bridge.vue?vue&type=template&id=3dbdea84"
import script from "./Bridge.vue?vue&type=script&lang=js"
export * from "./Bridge.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__